import { Col, Container, Image, Row } from "react-bootstrap"
import LoginForm from "../components/LoginForm"
import bgLogin from  '../img/bg.png'
import lBienvenidos from '../img/bgLetter.png'
import { useState } from "react"
import RegisterForm from "../components/RegisterForm"
import { withTranslation } from "react-i18next"
import DobleAutenticacionFactor from "../components/DobleAutenticacionFactor"
import GetLogoSistema from "../utils/getLogoSistema"

function SignUp({t}){
    const [isLogin,setLogin] = useState(true)
    const [isSuccess, setSuccess] = useState(false)
    const [objetoLogin, setObjetoLogin] = useState(null)  
    const logo = GetLogoSistema('logo')

    return (
        <div className="main bgLogin">
            {
                isSuccess ? 
                <DobleAutenticacionFactor 
                    objetoLogin={objetoLogin}
                />:
                <Container fluid className="p-md-0">
                <Row>
                    <Col md="6" className="d-none d-md-block vh-100 overflow-hidden">
                        <Image src={bgLogin} fluid/>
                        <Image src={lBienvenidos} fluid className="letter-bienvenidos"/>
                    </Col>
                    <Col md="6" xs="12" className="vh-100 overflow-y-auto">
                        <div className="wLogin  m-auto h-scrollbar">
                            <Row className="text-center mt-4">
                                <Col xs="12" md="12">
                                    {
                                        logo === undefined ? 
                                        <div className="spinner-border text-secondary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div> :
                                        <Image src={logo} fluid className="mh-150"/>
                                    }
                                    
                                </Col>                            
                            </Row>
                            {
                                isLogin ? 
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h3 className="text-primary1 font-weight-bold-600 mt-5 mb-2">{t('BienvenidoIkeasistencia')}</h3>
                                            {/* <label className="text-primary1">{t('Notienescuenta')} <strong className="cursor-pointer" onClick={e=>setLogin(false)}>{t('Registrate')}</strong></label> */}
                                        </Col>
                                        <Col xs="12" md="12">
                                            <LoginForm 
                                                setSuccess={setSuccess}
                                                setObjetoLogin={setObjetoLogin}
                                            />
                                        </Col>                            
                                    </Row> :
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h5 className="text-primary1 font-weight-bold-600 mt-5 mb-2">{t('Registrousuario')}</h5>
                                            <label className="text-primary1">{t('Ingresadatoscuenta')}</label>
                                        </Col>
                                        <Col xs="12" md="12"><RegisterForm setLogin={setLogin}/></Col>                            
                                    </Row> 
                            }
                        </div>
                        
                        
                    </Col>
                </Row>
            </Container>
            }
        </div>        
    )
}

export default withTranslation()(SignUp)